import {
  lucideArrowLeft,
  lucideCalendar,
  lucideCamera,
  lucideCheck,
  lucideChevronDown,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideEye,
  lucideEyeOff,
  lucideGlobe,
  lucideInfo,
  lucideKeyRound,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucidePhone,
  lucideRefreshCw,
  lucideUserCheck,
  lucideX,
} from '@ng-icons/lucide';

export const ICONS_MAP = {
  lucideArrowLeft,
  lucideCalendar,
  lucideCamera,
  lucideCheck,
  lucideChevronDown,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideEye,
  lucideEyeOff,
  lucideGlobe,
  lucideInfo,
  lucideKeyRound,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucidePhone,
  lucideRefreshCw,
  lucideUserCheck,
  lucideX,
};

type LucideIcon = keyof typeof ICONS_MAP;

export const ICONS_NAME_MAP = {
  'arrow-left': 'lucideArrowLeft',
  'calendar': 'lucideCalendar',
  'camera': 'lucideCamera',
  'check': 'lucideCheck',
  'chevron-down': 'lucideChevronDown',
  'circle-alert': 'lucideCircleAlert',
  'circle-check': 'lucideCircleCheck',
  'email': 'lucideMail',
  'eye-off': 'lucideEyeOff',
  'eye': 'lucideEye',
  'info': 'lucideInfo',
  'key-round': 'lucideKeyRound',
  'lock-keyhole': 'lucideLockKeyhole',
  'mail-check': 'lucideMailCheck',
  'phone': 'lucidePhone',
  'refresh-cw': 'lucideRefreshCw',
  'user-check': 'lucideUserCheck',
  'website': 'lucideGlobe',
  'x': 'lucideX',
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS_NAME_MAP;
